import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface PaginationProps {
	total?: number;
	limit?: number;
	currentPage?: number;
	style?: React.CSSProperties;
	onChangePage: (page: number) => void;
}

export function Pagination({ style, total = 0, currentPage = 1, limit = 8, onChangePage }: Readonly<PaginationProps>) {
	const currentPageNumber = currentPage === 0 ? 1 : currentPage;

	return (
		<Row align="middle" justify="space-between" style={style}>
			<Col>
				<S.PaginationInfo>
					{I18n.get('Showing')}{' '}
					{total === 1
						? 1
						: `${(currentPageNumber - 1) * limit + 1}-${Math.min(currentPageNumber * limit, total)}`}{' '}
					{I18n.get('of')} {total}
				</S.PaginationInfo>
			</Col>
			<Col>
				<S.PaginationCustom
					current={currentPageNumber}
					onChange={onChangePage}
					hideOnSinglePage={false}
					showSizeChanger={false}
					pageSize={limit}
					total={total}
				/>
			</Col>
		</Row>
	);
}
